import * as React from "react";
import SaveDialogLayout from "components/DialogLayout/SaveDialogLayout";
import {DataBaseComponent, DataBaseComponentState} from "components/DataBaseComponent";
import repository from "client/repository";
import {ReefResource} from "client/resources/reefResource";

interface Props {
    reefId: string;
    isInstanceUsageReportingEnabled: boolean;
    onChange: (reef: Partial<ReefResource>) => void;
}

type State = DataBaseComponentState;

class ChangeInstanceUsageReportingDialog extends DataBaseComponent<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {};
    }

    render() {
        return <SaveDialogLayout title={"Instance Usage Reporting"}
            busy={this.state.busy}
            errors={this.state.errors}
            saveButtonLabel={"Yes"}
            cancelButtonLabel={"No"}
            onSaveClick={() => this.changInstanceUsageReporting()}>
            <p>Are you sure you want to <b>{!this.props.isInstanceUsageReportingEnabled ? "enable" : "disable"}</b> Instance usage reporting for this Reef?</p>
        </SaveDialogLayout>;
    }

    private async changInstanceUsageReporting(): Promise<boolean> {
        return this.doBusyTask(async () => {
            const isInstanceUsageReportingEnabled: boolean = !this.props.isInstanceUsageReportingEnabled;
            await repository.Reefs.changeInstanceUsageReporting(this.props.reefId, {IsInstanceUsageReportingEnabled: isInstanceUsageReportingEnabled});
            this.props.onChange({EnableReporting: isInstanceUsageReportingEnabled});
        });
    }
}

export default ChangeInstanceUsageReportingDialog;
